"use client";

import { useQuery } from "@tanstack/react-query";

import { TTL } from "@/config/ttl";
import type { TokenInfo } from "@/domain/types";
import { apiFetch } from "@/lib/apiFetch";

async function fetchTokenList(): Promise<TokenInfo[]> {
  const data = await apiFetch<{ tokens: TokenInfo[] }>("/api/tokens");
  return data.tokens;
}

export function useTokenList() {
  return useQuery({
    queryKey: ["tokens"],
    queryFn: fetchTokenList,
    staleTime: TTL.tokens,
  });
}
